export const API_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}/web`;
export const ALTERAPI_BASE_URL = `${process.env.REACT_APP_ALTERAPI_BACKEND_HOST}/webapi`;

const routes = {
  API_USER_PROFILE: `/singleuser01`,
  API_POST: `/postandcomments`,
  API_GET_QUESTION: '/question/singlequestionanswer',
}

export default routes;